import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";

function SubmitButton({ loading, className, label }) {
    const [loadingIcon, setloadingIcon] = useState("");

    useEffect(() => {
        if (loading) {
            setloadingIcon("pi pi-spin pi-spinner");
        } else {
            setloadingIcon("");
        }
    }, [loading]);

    return <Button className={className} label={label} icon={loadingIcon || ""} iconPos="right" disabled={loading} />;
}

export default SubmitButton;
